import React from 'react'
import { Link } from 'react-router-dom'
import { Carousel } from 'antd';
import {RightOutlined,LeftOutlined} from '@ant-design/icons';
import styles from '../index.module.scss'
import { changeImg } from '../pub'
class TopSwiper extends React.Component {
  checkTurn=(val)=>{
    val=='L'?this.topCarousel.prev():this.topCarousel.next()
  }
  
  render() {
    const { lmtjData } = this.props
    return (
        <div className={styles.topSwiper}>
            <div className='swiperBox'>
              <div className='turnBtn turnBtn-l' onClick={()=>this.checkTurn('L')}><LeftOutlined /></div>
              <Carousel autoplay ref={c=>this.topCarousel=c}>
              {lmtjData.articles.slice(0,2).map(el=>{
                return (
                <div className='topSwiper-slide' key={el.id}>
                  {/* <Link to={`/unionCon?articleId=${el.id}&termId=${el.term_id}`} key={el.id}> */}
                    <img src={changeImg(el.smeta.photo[0].url)} alt="" />
                    {/* <p className='curatorTopSwText'>{el.post_title}</p> */}
                  {/* </Link> */}
                </div>
                )
              })
              }
              </Carousel>
              <div className='turnBtn turnBtn-R' onClick={()=>this.checkTurn('R')}><RightOutlined/></div>
            </div>
            {lmtjData.articles.slice(0,1).map(el=>{
                return (
                  <div className='topSwiperMsgBox'>
                    <div className={styles.title_type_1}>
                      <span 
                        dangerouslySetInnerHTML={{
                          __html: el.post_title.split('|').join("<br />"),
                        }} >
                      </span>
                      <i className={styles.i_large2}></i>
                      <i className={styles.i_small2}></i>  
                    </div>
                    <Link to={`/UnionCgCon?articleId=${el.id}&termId=${el.term_id}`} key={el.id}>
                      <p 
                      dangerouslySetInnerHTML={{
                        __html: el.post_content,
                      }} className='topSwiperMsg-msg'>
                      </p>
                    </Link>

                  </div>
                )
              })
            }
           
            
        </div>
    )
  }
}
export default TopSwiper
